module.exports = __webpack_public_path__ + "media/user_joinedroom.fe8e76f0.mp3";